import { render, staticRenderFns } from "./WaitingTime.vue?vue&type=template&id=79fbabb4"
import script from "./WaitingTime.vue?vue&type=script&lang=js"
export * from "./WaitingTime.vue?vue&type=script&lang=js"
import style0 from "./WaitingTime.vue?vue&type=style&index=0&id=79fbabb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports